import { CURRENT_POLICY_VERSION } from '../../constants'
import store from '../../store/index'

export const enforceView = (to, from, next) => {
  const view = to.meta.view
  if (view && view !== store.getters.view) {
    store.commit('setView', { view })
  }

  next()
}

export const requiresValidProfile = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresValidProfile)) {
    if (!store.getters.hasValidProfile) {
      next('/profil/hianyzo-adatok')
      return
    }

    if (store.getters.isPrivate && store.getters.isUnderage) {
      next('/a-funkcio-nem-elerheto')
      return
    }

    next()
  } else {
    next()
  }
}

export const requiresPrivacyPolicyConsent = (to, from, next) => {
  if (
    to.path !== '/profil/adatvedelmi-tajekoztato-elfogadasa' &&
    to.matched.some(record => record.meta.requiresAuth) &&
    store.getters.acceptedPolicyVersion !== CURRENT_POLICY_VERSION
  ) {
    next('/profil/adatvedelmi-tajekoztato-elfogadasa')
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/guards/profile.js